type AwaitingCardRow = {
  firstChargeOn?: string | null;
  canLinkCard?: boolean;
  status: string;
  id: string;
};

/**
 * The client's OTHER memberships a card just linked could start as well: still
 * waiting for their card (never one running on trust — taking that over by
 * card stays the client's own click), where the server accepts the link
 * (`canLinkCard`) and no first charge is already on its way.
 */
export const membershipsAwaitingCard = <T extends AwaitingCardRow>(
  rows: T[],
  activatedId: string,
) =>
  rows.filter(
    (row) =>
      row.id !== activatedId &&
      row.status === 'PENDING_PAYMENT_METHOD' &&
      row.canLinkCard === true &&
      !row.firstChargeOn,
  );

/** What those rows cost together — per currency, never added across. */
export const totalsByCurrency = (
  rows: Array<{ finalPrice?: number; currency: string }>,
) => {
  const totals = new Map<string, number>();
  for (const row of rows) {
    totals.set(
      row.currency,
      (totals.get(row.currency) ?? 0) + Number(row.finalPrice ?? 0),
    );
  }
  return Array.from(totals, ([currency, amount]) => ({ amount, currency }));
};
